"use strict";

import angular from "angular";

import { EventEmitterAdapter } from "../../../../presentation/adpters/EventEmitterAdapter/EventEmitterAdapter";
import { Events } from "../../../../presentation/services/Events/Events";

export class UpdateConecteDialogController {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;

        this.linkWindows = publicSettings.downloadElectron.Windows;
        this.linkMac = publicSettings.downloadElectron.Mac;

        this.EventEmitterAdapter = new EventEmitterAdapter();
        this.Events = new Events();
    }

    $onInit() {}

    async onDownloadConecte(os) {
        const link = os === "windows" ? this.linkWindows : this.linkMac;
        this.Events.send(`Conecte.Update.${os}`);
        window.open(link);
    }
}

angular.module("nucont.shared")
    .controller("UpdateConecteDialogController", [
        "$mdDialog",
        "locals",
        UpdateConecteDialogController
    ]);
